KMVP.kmcQuoteEdit = {
    bind: function() {
        $(document).on('click', '.js-quote-line-item-edit-button', this.edit.bind(this));
        $(document).on('click', '.js-quote-line-item-delete-button', this.delete.bind(this));
        $(document).on('click', '.js-quote-line-item-edit-undo', this.undo.bind(this));
        $(document).on('click', '.js-quote-edit-undo-all', this.undoAll);
        $(document).on('click', '.js-confirm-quote-line-item-edit', this.confirmLineItemEdit);
    },
    edit: function(e) {
        var quoteEntryData = this.getQuoteEntryData(e);
        KMVP.kmcQuoteEditModal.showEditModal(quoteEntryData);
        return false;
    },
    delete: function(e) {
        var quoteEntryData = this.getQuoteEntryData(e);
        KMVP.kmcQuoteEditStorage.deleteQuoteEntry(quoteEntryData.quoteId, quoteEntryData.entryLine, quoteEntryData.quantity);
        return false;
    },
    undo: function(e) {
        var quoteEntryData = this.getQuoteEntryData(e);
        KMVP.kmcQuoteEditStorage.undoEditChanges(quoteEntryData.quoteId, quoteEntryData.entryLine);
        return false;
    },
    undoAll: function(e) {
        var quoteId = e.target.dataset.quoteId;
        KMVP.kmcQuoteEditStorage.undoAllInQuote(quoteId);
        return false;
    },
    getQuoteEntryData: function(e) {
        var dataset = e.target.dataset;
        return {
            quoteId: String(dataset.quoteId),
            entryLine: dataset.entryLine,
            // filled only by edit
            description: dataset.description,
            domestic: dataset.domestic,
            dimensions: dataset.dimensions,
            quantity: String(Number(dataset.quantity)),
            unit: dataset.unit
        };
    },
    confirmLineItemEdit: function() {
        KMVP.kmcQuoteEditModal.hideEditModal();
    }
};

$(document).ready(function() {
    if ($('.js-kmc-quote-detail-page.js-kmc-quote-status-quote').length){
        KMVP.kmcQuoteEdit.bind();
    }
});
